import React, { useEffect, useState } from "react";
import Select from 'react-select';

const ImageLinkModal = ({ editor, onClose }) => {
    const [images, setImages] = useState([]);
    const [selectedImageId, setSelectedImageId] = useState("");
    useEffect(() => {
        if (!editor) return;

        const json = editor.getJSON();
        const foundImages = [];

        const traverse = (node) => {
            if (!node) return;
            if (node.type === "imageBlock" && node.attrs?.images) {
                node.attrs.images.forEach((img) => {
                    if (!img) return;
                    foundImages.push({
                        id: img.id,
                        url: img.url,
                        label: img.label || `Image ${img.id}`,
                        description: img.description || img.label || "",
                    });
                });
            }
            if (node.content && Array.isArray(node.content)) {
                node.content.forEach(traverse);
            }
        };

        traverse(json);
        setImages(foundImages);

        const attrs = editor.getAttributes("imageBlock");
        console.log("attrs",attrs);
        if (attrs?.imageId) {
            setSelectedImageId(attrs.imageId);
        }
    }, [editor]);

    const handleSave = () => {
        if (!selectedImageId) {
            editor.chain().focus().unsetImageLink().run();
            onClose();
            return;
        }

    const selectedImg = images.find((img) => img.id === selectedImageId);
    if (selectedImg) {
            editor
                .chain()
                .focus()
                .setImageLink({
                    imageId: selectedImg.id,
                    url: selectedImg.url,
                    label: selectedImg.label,
                    description: selectedImg.description,
                })
                .run();
        }
        onClose();
    };

    const getActiveImageLinkNode = (editor) => { 
        if (!editor) return null; const isActive = editor.isActive('imageLink'); 
        if (!isActive) return null; return editor.getAttributes('imageLink'); 
    };

    const imageLink = getActiveImageLinkNode(editor); 
    if (imageLink && !selectedImageId) { 
        console.log(imageLink.imageId); 
        setSelectedImageId(imageLink.imageId); 
    }

    const selectedImg = images.find(img => img.id === selectedImageId);
    const imageOptions = images.map(img => ({
        value: img.id,
        label: img.label
    }));

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: "400px" }}>
                <div className="modal-header">
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                        <h3 style={{ margin: 0 }}>Link Image to Text</h3>
                        <button onClick={onClose} className="btn btn-ghost" style={{ padding: "0.25rem" }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                        </button>
                    </div>
                    
                </div>
                    <p style={{ fontSize: "0.875rem", color: "var(--text-muted)", marginTop: "0.5rem" }}>
                        Choose an image from the current block to link to the selected text.
                    </p>
                <div style={{ marginBottom: "1.5rem" }}>
                    <label className="label-modern">Select Gallery Image</label>
                    <Select
                        options={images.map(img => ({
                            value: img.id,
                            label: img.label
                        }))}
                        onChange={(option) => setSelectedImageId(option?.value || "")}
                        value={imageOptions.find(opt => opt.value === selectedImageId) || null}
                        />
                    {/* <select
                        className="input-modern"
                        value={selectedImageId}
                        onChange={(e) => setSelectedImageId(e.target.value)}
                    >
                        <option value="">-- Choose an Image --</option>
                        {images.map((img) => (
                            <option key={img.id} value={img.id}>
                                {img.label}
                            </option>
                        ))}
                    </select> */}
                </div>

                {selectedImg && (
                    <div style={{ marginBottom: "1.5rem", padding: "0.75rem", background: "var(--bg-main)", borderRadius: "var(--radius-md)", textAlign: "center" }}>
                        <div style={{ fontSize: "0.75rem", color: "var(--text-muted)", marginBottom: "0.5rem", fontWeight: 600, textTransform: "uppercase" }}>Preview</div>
                        {selectedImg.url ? (
                            <img
                                src={`${process.env.REACT_APP_MEDIA_URL}/${selectedImg.url}`}
                                alt="Preview"
                                style={{ maxWidth: "100%", maxHeight: "150px", borderRadius: "var(--radius-md)", boxShadow: "var(--shadow-sm)" }}
                            />
                        ) : (
                            <div style={{ height: "100px", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--text-muted)" }}>
                                No preview available
                            </div>
                        )}
                    </div>
                )}

                <div style={{ display: "flex", justifyContent: "flex-end", gap: "1rem", marginTop: "1rem" }}>
                    <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
                    <button 
                        className="btn btn-primary" 
                        onClick={handleSave}
                        style={{ minWidth: "120px" }}
                    >
                        {selectedImageId ? "Link Image" : "Remove Link"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ImageLinkModal;
